export const styles = {
    container: {
        bg: "gray.150",
        display: "flex",
        px: 2,
        py: 1,
        maxHeight: "6",
    },
};
